import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isSavingProfile: boolean;
  isChangingPassword: boolean;
  isChangingEmail: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isSavingProfile: false,
  isChangingPassword: false,
  isChangingEmail: false,
  fields: [],
  translatedMessage: ""
};

export const userProfileReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_REQUEST:
      return {...state,
        isSavingProfile: true,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_REQUEST:
      return {...state,
        isChangingPassword: true,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_REQUEST:
      return {...state,
        isChangingEmail: true,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_SUCCESS:
      return {...state,
        isSavingProfile: false,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_SUCCESS:
      return {...state,
        isChangingPassword: false,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_SUCCESS:
      return {...state,
        isChangingEmail: false,
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_FAILURE:
      return {...state,
        isSavingProfile: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_FAILURE:
      return {...state,
        isChangingPassword: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_FAILURE:
      return {...state,
        isChangingEmail: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_SETTINGS_USER_PROFILE_CLEAR:
    case Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
